import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'DepartmentIcon',
  functional: true,
  render: function render(h, ctx) {
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 480 480",
        fill: "currentColor",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      },
      "class": "feather"
    }, ctx.data]), [
      h("path", {
        attrs: {
          d: "M472,76h-88V12c0-4.418-3.582-8-8-8H104c-4.418,0-8,3.582-8,8v112H8c-4.418,0-8,3.582-8,8v328c0,4.418,3.582,8,8,8s8-3.582,8-8V140h80v328c0,4.418,3.582,8,8,8h272c4.418,0,8-3.582,8-8V92h80v368c0,4.418,3.582,8,8,8s8-3.582,8-8V84C480,79.582,476.418,76,472,76z M232,460h-32v-72h32V460z M280,460h-32v-72h32V460z M368,460h-72v-80c0-4.418-3.582-8-8-8h-96c-4.418,0-8,3.582-8,8v80h-72V20h256V460z"
        }
      }),
      h("path", {
        attrs: {
          d: "M184,36h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V44C192,39.582,188.418,36,184,36zM176,84h-32V52h32V84z"
        }
      }),
      h("path", {
        attrs: {
          d: "M264,36h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V44C272,39.582,268.418,36,264,36zM256,84h-32V52h32V84z"
        }
      }),
      h("path", {
        attrs: {
          d: "M344,36h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V44C352,39.582,348.418,36,344,36zM336,84h-32V52h32V84z"
        }
      }),
      h("path", {
        attrs: {
          d: "M184,116h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C192,119.582,188.418,116,184,116zM176,164h-32v-32h32V164z"
        }
      }),
      h("path", {
        attrs: {
          d: "M264,116h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C272,119.582,268.418,116,264,116zM256,164h-32v-32h32V164z"
        }
      }),
      h("path", {
        attrs: {
          d: "M344,116h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C352,119.582,348.418,116,344,116zM336,164h-32v-32h32V164z"
        }
      }),
      h("path", {
        attrs: {
          d: "M184,196h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C192,199.582,188.418,196,184,196zM176,244h-32v-32h32V244z"
        }
      }),
      h("path", {
        attrs: {
          d: "M264,196h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C272,199.582,268.418,196,264,196zM256,244h-32v-32h32V244z"
        }
      }),
      h("path", {
        attrs: {
          d: "M344,196h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C352,199.582,348.418,196,344,196zM336,244h-32v-32h32V244z"
        }
      }),
      h("path", {
        attrs: {
          d: "M184,276h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C192,279.582,188.418,276,184,276zM176,324h-32v-32h32V324z"
        }
      }),
      h("path", {
        attrs: {
          d: "M264,276h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C272,279.582,268.418,276,264,276zM256,324h-32v-32h32V324z"
        }
      }),
      h("path", {
        attrs: {
          d: "M344,276h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C352,279.582,348.418,276,344,276zM336,324h-32v-32h32V324z"
        }
      }),
      h("path", {
        attrs: {
          d: "M48,156h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C56,159.582,52.418,156,48,156z"
        }
      }),
      h("path", {
        attrs: {
          d: "M80,156h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C88,159.582,84.418,156,80,156z"
        }
      }),
      h("path", {
        attrs: {
          d: "M48,188h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C56,191.582,52.418,188,48,188z"
        }
      }),
      h("path", {
        attrs: {
          d: "M80,188h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C88,191.582,84.418,188,80,188z"
        }
      }),
      h("path", {
        attrs: {
          d: "M48,220h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C56,223.582,52.418,220,48,220z"
        }
      }),
      h("path", {
        attrs: {
          d: "M80,220h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C88,223.582,84.418,220,80,220z"
        }
      }),
      h("path", {
        attrs: {
          d: "M48,252h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C56,255.582,52.418,252,48,252z"
        }
      }),
      h("path", {
        attrs: {
          d: "M80,252h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C88,255.582,84.418,252,80,252z"
        }
      }),
      h("path", {
        attrs: {
          d: "M48,284h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C56,287.582,52.418,284,48,284z"
        }
      }),
      h("path", {
        attrs: {
          d: "M80,284h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C88,287.582,84.418,284,80,284z"
        }
      }),
      h("path", {
        attrs: {
          d: "M48,316h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C56,319.582,52.418,316,48,316z"
        }
      }),
      h("path", {
        attrs: {
          d: "M80,316h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C88,319.582,84.418,316,80,316z"
        }
      }),
      h("path", {
        attrs: {
          d: "M48,348h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C56,351.582,52.418,348,48,348z"
        }
      }),
      h("path", {
        attrs: {
          d: "M80,348h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C88,351.582,84.418,348,80,348z"
        }
      }),
      h("path", {
        attrs: {
          d: "M48,380h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C56,383.582,52.418,380,48,380z"
        }
      }),
      h("path", {
        attrs: {
          d: "M80,380h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C88,383.582,84.418,380,80,380z"
        }
      }),
      h("path", {
        attrs: {
          d: "M48,412h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C56,415.582,52.418,412,48,412z"
        }
      }),
      h("path", {
        attrs: {
          d: "M80,412h-8c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8h8c4.418,0,8-3.582,8-8v-8C88,415.582,84.418,412,80,412z"
        }
      }),
      h("path", {
        attrs: {
          d: "M440,108h-32c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h32c4.418,0,8-3.582,8-8v-32C448,111.582,444.418,108,440,108zM432,140h-16v-16h16V140z"
        }
      }),
      h("path", {
        attrs: {
          d: "M440,172h-32c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h32c4.418,0,8-3.582,8-8v-32C448,175.582,444.418,172,440,172zM432,204h-16v-16h16V204z"
        }
      }),
      h("path", {
        attrs: {
          d: "M440,236h-32c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h32c4.418,0,8-3.582,8-8v-32C448,239.582,444.418,236,440,236zM432,268h-16v-16h16V268z"
        }
      }),
      h("path", {
        attrs: {
          d: "M440,300h-32c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h32c4.418,0,8-3.582,8-8v-32C448,303.582,444.418,300,440,300zM432,332h-16v-16h16V332z"
        }
      }),
      h("path", {
        attrs: {
          d: "M440,364h-32c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h32c4.418,0,8-3.582,8-8v-32C448,367.582,444.418,364,440,364zM432,396h-16v-16h16V396z"
        }
      }),




    ]);
  }
};